import { render, staticRenderFns } from "./MpError.vue?vue&type=template&id=243e5dc6&scoped=true&"
import script from "./MpError.vue?vue&type=script&lang=js&"
export * from "./MpError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243e5dc6",
  null
  
)

export default component.exports